import styled from 'styled-components'

export const HeaderFilters = styled.div`
  align-self: end;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin: 0 12px;
`
